import React from "react";
import Select from "react-select";
import "./DropdownSelect.scss";

const DropdownSelect = ({
  value,
  handleDropdownChange,
  handleDropdownBlur,
  optionsValue,
  isMultiSelect,
  placeholder,
  isDropdownDisabled,
  isdropdownOpen,
  dataField
}) => {
  return (
    <span className="d-inline-block custom-input">
      <Select
        className="custom-checkbox-select"
        value={value || null}
        onChange={handleDropdownChange}
        options={optionsValue}
        isMulti={isMultiSelect}
        placeholder={placeholder}
        onBlur={handleDropdownBlur}
        isDisabled={isDropdownDisabled}
        closeMenuOnSelect={isMultiSelect ? !!isdropdownOpen : true}
        name={dataField}
      />
    </span>
  );
}

export default React.memo(DropdownSelect);
